import { useQuery } from '@tanstack/react-query';
import { fetchMarketBoardHts } from '@apis/indices';
import type { IndicesHtsInterval, IndicesMarketGroup } from '@app-types/indices';
import type { MarketBoardHtsApiResponse } from '@app-types/summaryApi';
import { getAccessToken } from '@utils/authStorage';

export const buildMarketBoardHtsQueryKey = (
  mktGroup: IndicesMarketGroup,
  interval: IndicesHtsInterval,
  rics: readonly string[],
) => [
  'marketBoardHts',
  mktGroup,
  interval,
  rics.join(';'),
] as const;

export const useMarketBoardHts = (
  mktGroup: IndicesMarketGroup,
  interval: IndicesHtsInterval,
  rics: readonly string[],
  quotesReady: boolean,
) => {
  const hasToken = Boolean(getAccessToken());
  return useQuery<MarketBoardHtsApiResponse>({
    queryKey: buildMarketBoardHtsQueryKey(mktGroup, interval, rics),
    queryFn: () => fetchMarketBoardHts({ rics, interval }),
    enabled: Boolean(hasToken && quotesReady && rics.length > 0),
    staleTime: Infinity,
    retry: 1,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
